export type PresenterKeyAction =
  | 'next'
  | 'prev'
  | 'first'
  | 'last'
  | 'close'
  | 'blackout'
  | 'toggleTimer';

export function resolvePresenterKey(key: string): PresenterKeyAction | null {
  if (key === 'Escape') return 'close';
  if (key === 'ArrowRight' || key === ' ' || key === 'PageDown' || key === 'Enter') return 'next';
  if (key === 'ArrowLeft' || key === 'PageUp' || key === 'Backspace') return 'prev';
  if (key === 'Home') return 'first';
  if (key === 'End') return 'last';
  if (key === 'b' || key === 'B') return 'blackout';
  if (key === 'p' || key === 'P') return 'toggleTimer';
  return null;
}

export function nextPresenterIndex(index: number, length: number): number {
  if (length <= 0) return 0;
  return Math.min(length - 1, index + 1);
}

export function prevPresenterIndex(index: number, length: number): number {
  if (length <= 0) return 0;
  return Math.max(0, index - 1);
}

export function formatPresenterElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function formatPresenterClock(now: Date): string {
  return now.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
}
